var $fae22a4281aba2b9$exports = {};
$fae22a4281aba2b9$exports = {
    "help": `Pal\u{12B}dz\u{12B}ba`,
    "info": `Inform\u{101}cija`
};


export {$fae22a4281aba2b9$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
